import { LOCATION_TYPES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/location_types_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'locationTypesIndex',
	'locationsAdvancedFilters',
	'locationFormIndex',
	'LOCATION_FORM_LOCATION_TYPES_AUTOCOMPLETE',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
